import IconBox from '../../components/common/icon-box'
import MainNav from '../../components/homepage/main-nav'
import Layout from '../../components/layout/layout'
import InfoMessage from '../../components/common/info-message'
import { useTranslation } from '../../useTranslation'
import Button from '../../components/common/button'
import { Link } from 'react-router-dom'

const NewsletterSuccess = () => {
    const { t } = useTranslation()
    return (
        <Layout>
            <MainNav />
            <div className="mx-auto my-16 w-3/6 max-tablet:w-2/3">
                <IconBox icon="address-card">
                    <div className="py-10 px-2">
                        <InfoMessage type="success" label={t('footer.newsletter.newsletterSuccess')} icon="check" dataCy="newsletter-success-message" />
                        <div className="flex justify-center mt-7 gap-3">
                            <Link to="/">
                                <Button text={t('backToRingo')} type="squareBlue" dataCy="newsletter-success-back-home" />
                            </Link>
                        </div>
                    </div>
                </IconBox>
            </div>
        </Layout>
    )
}

export default NewsletterSuccess
